import React, { memo } from 'react';
import { Text, View, Image } from 'react-native';
import {
  COLOR,
  FONT,
  FONT_SIZE,
  THEME,
  THEME_DARK,
  __WEB__,
  SELECT_STYLE,
} from '../../constants/styles';
import {
  OPComponent,
  CTAButton,
  I18n,
  Utils,
  NavBar,
  Container,
  Navigation,
  CheckButtonList,
  FormInput,
  DatePicker,
  Select,
  FormHelpers,
} from '../components';

import moment from 'moment';

import { styles, Header } from './common_ui';

import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../actions/statusTypes';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getFormData, getQuestionnaire, putFormData, submitForm, validateForm } from './actions';

import {
  SCREENS,
  QUESTIONS,
  SECTIONS,
  SUBQUESTIONS,
  AGENT_ENABLED,
  setQuestionnaire,
} from './questionnaire';
import { setMode } from './service';
import AddOrRemoveButton from './add_button';
import Sidenav from './sidenav';
import {
  firstUnAnsweredScreen,
  nextScreen,
  previousScreen,
  firstScreenInSection,
  questionMeetsConditions,
  screenMeetsConditionsAndAnsweredAndValid,
  sectionForScreen,
} from './helpers';

const REFS = {};

const containerRef = React.createRef();

const CUSTOM_SELECT_STYLE = {
  ...SELECT_STYLE,
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      ...FONT.regular,
      backgroundColor: isFocused ? '#999999' : null,
      color: 'black',
      fontSize: 16,
    };
  },
  singleValue: (base, state) => ({
    ...base,
    ...FONT.regular,
    fontSize: 16,
  }),
  placeholder: (base, state) => ({
    ...base,
    ...FONT.regular,
    fontSize: 16,
  }),
};

const TextQuestion = memo(function (props) {
  async function handleChange(text) {
    if (text) {
      await props.onAnswer({ ...props.question, answer: text });
    } else {
      await props.onRemoveAnswers([props.question.questionId]);
    }
    if (text && props.question.invalidates?.length) {
      props.onRemoveAnswers(props.question.invalidates);
    }
  }
  return (
    <>
      {!!props.question.label && (
        <Text style={styles.questionLabel}>
          <div dangerouslySetInnerHTML={{ __html: props.question.label }} />
        </Text>
      )}
      <FormInput
        ref={(ref) => {
          REFS[props.question.questionId] = ref;
        }}
        autoValidate={false}
        required={props.question.required !== false}
        controlled={true}
        value={props.answer || ''}
        label={props.question.q}
        onChangeText={handleChange}
        onSubmitEditing={null}
        maxLength={props.question.maxLength}
        validateFunc={
          props.question.validationType ? Utils.validate[props.question.validationType] : null
        }
        inputStyle={{ fontSize: FONT_SIZE.regular }}
      />
    </>
  );
});
function DateQuestion(props) {
  function handleChange(date) {
    props.onAnswer({ ...props.question, answer: moment(new Date(date)).format('YYYY-MM-DD') });
  }
  return (
    <DatePicker
      ref={(ref) => {
        REFS[props.question.questionId] = ref;
      }}
      autoValidate={false}
      label={props.question.q}
      validateFunc={Utils.validate[props.question.validationType || 'date']}
      required={props.question.required !== false}
      onDate={handleChange}
      selectedDate={props.answer ? moment(props.answer).toDate() : null}
      mode="date"
      calendarIcon={
        <Image
          style={styles.calImage}
          source={require('../../../resources/nav-icon-calendar.png')}
        />
      }
      className="react-date-picker-part-a"
    />
  );
}
function SelectQuestion(props) {
  function handleChange(val) {
    props.onAnswer({ ...props.question, answer: val.id });
  }
  const options = props.question.options.map((o) => ({ id: o, label: o }));
  return (
    <>
      {!!props.question.label && (
        <Text style={styles.questionLabel}>
          <div dangerouslySetInnerHTML={{ __html: props.question.label }} />
        </Text>
      )}
      <Select
        ref={(ref) => {
          REFS[props.question.questionId] = ref;
        }}
        autoValidate={false}
        styles={{ ...CUSTOM_SELECT_STYLE }}
        required={props.question.required !== false}
        editable={true}
        closeOnSelect={true}
        options={options}
        label={props.question.q}
        value={
          props.answer
            ? {
                label: props.answer,
                id: props.answer,
              }
            : null
        }
        onValue={handleChange}
        webMode={true}
      />
    </>
  );
}
const CheckQuestion = memo(function (props) {
  // console.info('>>> CheckQuestion', props.question.q);
  const items = props.question.options.map((o) => ({
    label: props.question.layoutOptions?.noLabels ? null : o,
    id: o,
  }));
  async function handleSelection(val) {
    if (items.length === 1) {
      if (props.answer != null) {
        props.onRemoveAnswers([props.question.questionId]);
        return;
      }
    }
    if (props.answer !== val && props.question.invalidates?.length) {
      await props.onRemoveAnswers(props.question.invalidates, { withSubs: true });
    }
    if (val === null) {
      props.onRemoveAnswers([props.question.questionId]);
    } else {
      props.onAnswer({ ...props.question, answer: val });
    }
  }
  const showSubs = props.showSubs != null ? props.showSubs : props.answer != null;
  return (
    <>
      <View style={props.question.horizontal ? THEME.basicRow : null}>
        {!!props.question.label && (
          <Text
            style={[
              styles.questionLabel,
              { marginRight: 15 },
              props.question.horizontal ? styles.questionLabelHorizontal : null,
            ]}
          >
            <div dangerouslySetInnerHTML={{ __html: props.question.label }} />
          </Text>
        )}

        <CheckButtonList
          items={items}
          value={props.answer}
          multi={!!props.question.multi}
          other={!!props.question.other}
          customLayout={props.question.customLayout}
          onValue={handleSelection}
          containerStyle={props.question.layoutOptions?.horizontal ? { flexDirection: 'row' } : {}}
          labelStyle={{ fontSize: FONT_SIZE.regular }}
          rowContainerStyle={
            props.question.horizontal
              ? { flex: 1, paddingLeft: 25, paddingRight: 0 }
              : props.question.layoutOptions?.horizontal
                ? { flex: 1, paddingLeft: 0, paddingRight: 25 }
                : { paddingHorizontal: 0 }
          }
          noBottomBorder={true}
        />
      </View>

      {!!props.question.subQuestions?.length && showSubs && (
        <View style={styles.subQuestionContainer}>
          {!!props.question.subQuestionsLabel && (
            <Text style={[styles.questionLabel]}>
              <div dangerouslySetInnerHTML={{ __html: props.question.subQuestionsLabel }} />
            </Text>
          )}
          {props.question.subQuestions.map((sq) => {
            const sub = SUBQUESTIONS[sq] || QUESTIONS[sq];
            const CompName = QUESTIONS_COMPS[sub.type] || DefaultQuestion;
            return (
              <CompName
                key={sq}
                question={{ ...sub, questionId: `${props.question.questionId}_${sq}` }}
                onAnswer={props.onAnswer}
                onRemoveAnswers={props.onRemoveAnswers}
                answer={props.answers[`${props.question.questionId}_${sq}`]}
                answers={props.answers}
              />
            );
          })}
        </View>
      )}
    </>
  );
});

function YesNo(props) {
  // console.info('>>> YesNo', props.question)
  return (
    <>
      <CheckQuestion
        key={props.question.questionId}
        question={{
          ...props.question,
          layoutOptions: {
            horizontal: true,
            noLabels: true,
          },
          horizontal: true,
          options: ['No', 'Yes'],
          label: props.question.q,
        }}
        onAnswer={props.onAnswer}
        answer={props.answer}
        answers={props.answers}
        showSubs={props.answer === 'Yes'}
      />
    </>
  );
}

function MultiQuestion(props) {
  const items = Object.keys(props.answers).filter((qid) =>
    qid.startsWith(`${props.question.questionId}`)
  );
  const subCount = parseInt(
    items
      .map((item) => item.split('_')[1])
      .sort()
      .pop() || 0
  );
  const subsToRender = Array(subCount).fill(0);

  function addAnother() {
    props.onAnswer({ questionId: `${props.question.questionId}_${subCount + 1}`, answer: null });
  }
  function removeLast() {
    const toRemove = Object.keys(props.answers).filter((qid) =>
      qid.startsWith(`${props.question.questionId}_${subCount}`)
    );
    props.onRemoveAnswers(toRemove);
  }

  function renderSubs(na, i) {
    i = i + 1;
    return (
      <View key={i} style={{ borderBottomWidth: subCount > 1 ? 1 : 0, borderColor: COLOR.accent }}>
        {props.question.subQuestions.map((sq) => {
          const subQuestion = QUESTIONS[sq];
          const CompName = QUESTIONS_COMPS[subQuestion.type] || DefaultQuestion;
          return (
            <CompName
              key={sq}
              question={{ ...subQuestion, questionId: `${props.question.questionId}_${i}_${sq}` }}
              onAnswer={props.onAnswer}
              onRemoveAnswers={props.onRemoveAnswers}
              answer={props.answers[`${props.question.questionId}_${i}_${sq}`]}
              answers={props.answers}
            />
          );
        })}
        {subCount > 1 && i >= subCount && (
          <AddOrRemoveButton label={'Remove'} onPress={removeLast} remove={true} />
        )}
      </View>
    );
  }

  if (subCount === 0) {
    setTimeout(addAnother);
  }

  return (
    <>
      {!!props.question.label && (
        <Text style={styles.questionLabel}>
          <div dangerouslySetInnerHTML={{ __html: props.question.label }} />
        </Text>
      )}
      <View style={{ zIndex: 1000 }}>
        {!!props.question.subQuestions?.length && subsToRender.map(renderSubs)}
      </View>
      <AddOrRemoveButton label={props.question.addLabel} onPress={addAnother} />
    </>
  );
}

function DefaultQuestion(props) {
  return (
    <Text>
      Undefined question type: {props.question.type} {props.question.q}
    </Text>
  );
}

const QUESTIONS_COMPS = {
  text: TextQuestion,
  date: DateQuestion,
  select: SelectQuestion,
  check: CheckQuestion,
  yesno: YesNo,
  multi: MultiQuestion,
};

class PartAForm extends OPComponent {
  static navigatorStyle = NavBar.authNavbarStyle;
  static statusBarStyle = NavBar.authStatusBarStyle;

  constructor(props) {
    super(props);

    this.state = {
      currentSection: null,
      currentScreen: null,
      nextScreen: null,
      nextSection: null,
      lastSavedAnswers: null,
      answers: {},
      fieldsValid: true,
      sideNavOpen: false,
      questionnaireLoaded: false,
      validationError: null,
    };
  }
  async componentDidMount() {
    let fieldsValid = FormHelpers.validateFields(Object.values(REFS));
    this.setState({ fieldsValid });

    const questionnaire = await this.props.actions.getQuestionnaire(this.props.token);
    setQuestionnaire(questionnaire);
    await setMode(this.props.token, 'form');
    this.setState({ questionnaireLoaded: true });
    this.fetchSavedAnswers();
  }
  componentWillUnmount() {}

  componentDidUpdate(prevProps, prevState) {
    if (this.props.saveStatus === SUCCESS && prevProps.saveStatus !== SUCCESS) {
      this.next();
    }
    // after first fetch go to the first unanswered screen
    if (this.state.lastSavedAnswers && !prevState.lastSavedAnswers) {
      const { currentScreen, currentSection } = firstUnAnsweredScreen(this.state.lastSavedAnswers);
      if (currentScreen) {
        const nextOnes = nextScreen(currentScreen.screenId, {});
        this.setState({
          currentSection,
          currentScreen,
          nextScreen: nextOnes.currentScreen,
          nextSection: nextOnes.currentSection,
        });
      }
    } else if (this.state.answers !== prevState.answers) {
      const nextOnes = nextScreen(this.state.currentScreen.screenId, this.state.answers);
      let fieldsValid = FormHelpers.validateFields(Object.values(REFS));
      this.setState({
        fieldsValid,
        nextScreen: nextOnes.currentScreen,
        nextSection: nextOnes.currentSection,
      });
    }
    if (
      this.state.currentScreen !== prevState.currentScreen ||
      this.state.currentSection !== prevState.currentSection
    ) {
      containerRef.current?.scrollToTop({ animated: false });
      Object.keys(REFS).forEach((k) => {
        if (REFS[k] === null) delete REFS[k];
      });
      let fieldsValid = FormHelpers.validateFields(Object.values(REFS));
      this.setState({ fieldsValid });
    }
  }

  processLastSavedAnswers(answersArry) {
    const answers = {};
    answersArry.forEach((ans) => {
      answers[ans.question_id] = ans.answer;
    });
    return answers;
  }
  fetchSavedAnswers = () => {
    this.props.actions.getFormData(this.props.token).then((lastSavedAnswersArray) => {
      const lastSavedAnswers = this.processLastSavedAnswers(lastSavedAnswersArray);
      this.setState({
        lastSavedAnswers: { ...lastSavedAnswers },
        answers: { ...lastSavedAnswers } || {},
      });
    });
  };

  clearInvalidAnswers = async () => {
    // console.info('>>> clearInvalidAnswers', this.state.answers)
    const answerKeys = Object.keys(this.state.answers);
    let keysToRemove = [];
    answerKeys.forEach((questionKey) => {
      const questionId = questionKey.split('_')[0];
      const meetsConditions = questionMeetsConditions(questionId, this.state.answers);
      if (
        !meetsConditions ||
        (QUESTIONS[questionId].type === 'yesno' &&
          this.state.answers[questionId] !== 'Yes' &&
          questionId !== questionKey) ||
        this.state.answers[questionKey] === null
      ) {
        keysToRemove.push(questionKey);
      }
    });
    if (keysToRemove?.length) return this.handleRemoveAnswers(keysToRemove);
  };

  handleAnswer = (question, callback) => {
    // console.info('>>> handleAnswer', question.questionId, question.answer);
    const myPromise = new Promise((resolve, reject) => {
      this.setState(
        {
          answers: {
            ...this.state.answers,
            [question.questionId]: `${question.answer}`,
          },
        },
        resolve
      );
    });
    return myPromise;
  };

  handleRemoveAnswers = (questionIds, options) => {
    const myPromise = new Promise((resolve, reject) => {
      const answers = this.state.answers;
      let subIds = [];
      questionIds.forEach?.((id) => {
        delete answers[id];
        if (options?.withSubs) {
          subIds = Object.keys(this.state.answers).filter((k) => k.startsWith(`${id}_`));
        }
      });
      subIds?.forEach?.((id) => {
        delete answers[id];
      });
      this.setState({ answers: { ...answers } }, resolve);
    });
    return myPromise;
  };

  changesToSave() {
    const dataToSave = [];
    Object.keys(this.state.answers).forEach((k) => {
      if (this.state.answers[k] !== this.state.lastSavedAnswers[k]) {
        dataToSave.push({ question_id: k, answer: this.state.answers[k] });
      }
    });
    Object.keys(this.state.lastSavedAnswers).forEach((k) => {
      if (!this.state.answers[k]) {
        dataToSave.push({
          question_id: k,
          answer: this.state.lastSavedAnswers[k],
          is_active: false,
        });
      }
    });
    return dataToSave;
  }

  save = async () => {
    const props = this.props;
    await this.clearInvalidAnswers();
    const dataToSave = this.changesToSave();
    if (!dataToSave.length) {
      this.next();
      return;
    }

    props.actions
      .putFormData(this.props.token, { answers: dataToSave }, { ...this.state.answers })
      .then((lastSavedAnswers) => {
        // if the save fails lastSavedAnswers will be null
        if (lastSavedAnswers) this.setState({ lastSavedAnswers });
      });
  };

  next = () => {
    if (!this.state.nextScreen) {
      this.setState({
        currentScreen: null,
        currentSection: null,
      });
    } else {
      const nextOnes = nextScreen(this.state.nextScreen.screenId, this.state.answers);
      this.setState({
        currentScreen: this.state.nextScreen,
        currentSection: this.state.nextSection,
        nextScreen: nextOnes.currentScreen,
        nextSection: nextOnes.currentSection,
      });
    }
  };

  _cancelConfirm = () => {
    this.setState({ confirmationOpts: null });
  };
  _confirmPrevious = () => {
    const previousOnes = previousScreen(
      this.state.currentScreen?.screenId,
      this.state.lastSavedAnswers
    );
    if (!previousOnes.currentScreen) {
      this.setState({
        answers: this.state.lastSavedAnswers,
      });
    } else {
      this.setState({
        currentScreen: previousOnes.currentScreen,
        currentSection: previousOnes.currentSection,
        nextScreen: this.state.currentScreen,
        nextSection: this.state.currentSection,
        answers: this.state.lastSavedAnswers,
      });
    }
    this._cancelConfirm();
  };
  previous = () => {
    if (this.changesToSave().length) {
      const confirmationOpts = {
        title: 'You have unsaved changes',
        description: 'Are you sure you want to leave this screen without saving?',
        confirm: 'Yes, Discard my changes',
        onConfirmed: this._confirmPrevious,
        onCancelled: this._cancelConfirm,
      };

      this.setState({ confirmationOpts });
    } else {
      this._confirmPrevious();
    }
  };

  handleSelectSection = (section) => {
    if (this.changesToSave().length) {
      const confirmationOpts = {
        title: 'You have unsaved changes',
        description: 'Are you sure you want to leave this screen without saving?',
        confirm: 'Yes, Discard my changes',
        onConfirmed: () => {
          this._confirmSelectSection(section);
          this._cancelConfirm();
        },
        onCancelled: this._cancelConfirm,
      };

      this.setState({ confirmationOpts, sideNavOpen: false });
    } else {
      this._confirmSelectSection(section);
    }
  };
  _confirmSelectSection = (section) => {
    if (!section) {
      this.setState({
        currentScreen: null,
        currentSection: null,
        nextScreen: null,
        nextSection: null,
        sideNavOpen: false,
      });
    } else {
      const { currentScreen, currentSection } = firstScreenInSection(section, this.state.answers);
      const nextOnes = nextScreen(currentScreen.screenId, this.state.answers);
      this.setState({
        currentScreen,
        currentSection,
        nextScreen: nextOnes?.currentScreen,
        nextSection: nextOnes?.currentSection,
        sideNavOpen: false,
      });
    }
  };

  renderQuestion = (q) => {
    const question = QUESTIONS[q];
    // console.info('>>> renderQuestion', question.q)

    if (!questionMeetsConditions(q, this.state.answers)) return null;

    const CompName = QUESTIONS_COMPS[question.type] || DefaultQuestion;
    const returnElements = (
      <CompName
        key={question.questionId}
        question={question}
        onAnswer={this.handleAnswer}
        onRemoveAnswers={this.handleRemoveAnswers}
        answer={this.state.answers[question.questionId]}
        answers={question.subQuestions?.length ? this.state.answers : null}
      />
    );
    return returnElements;
  };

  renderQuestionGroup = (section, i) => {
    const renderedQuestions = section.questions.map(this.renderQuestion).filter((q) => q !== null);
    if (!renderedQuestions?.length) return null;
    return (
      <View style={styles.sectionContainer} key={i}>
        {!!section.orDivider && (
          <View style={styles.orDivider}>
            <View style={styles.orDividerLeft} />
            <Text style={styles.orText}>OR</Text>
            <View style={styles.orDividerRight} />
          </View>
        )}
        {!!section.label && <Text style={styles.sectionLabel}>{section.label}</Text>}
        <View style={styles.section}>
          {!!section.description && (
            <Text style={styles.questionLabel}>
              <div dangerouslySetInnerHTML={{ __html: section.description }} />
            </Text>
          )}
          {!!section.descriptionYesNo && (
            <View style={[THEME.basicRow, { justifyContent: 'flex-end', paddingRight: 4 }]}>
              <Text style={[THEME.textRegular, { marginRight: 34 }]}>NO</Text>
              <Text style={THEME.textRegular}>YES</Text>
            </View>
          )}
          {renderedQuestions}
        </View>
      </View>
    );
  };

  openMenu = () => {
    this.setState({ sideNavOpen: !this.state.sideNavOpen });
  };

  renderHeader() {
    return (
      <Header
        onPressPrevious={this.props.submitStatus !== SUCCESS && this.previous}
        label={this.state.currentSection?.label}
        onPressOpenMenu={this.props.submitStatus !== SUCCESS && this.openMenu}
      />
    );
  }

  renderSidenav() {
    return (
      <View
        style={[
          styles.sideNav,
          {
            transition: 'right 400ms ease-out',
            right: this.state.sideNavOpen ? 0 : -300,
          },
        ]}
      >
        <Sidenav answers={this.state.answers} onSelectSection={this.handleSelectSection} />
      </View>
    );
  }

  submit = async () => {
    const validation = await this.props.actions.validateForm(this.props.token);
    if (!validation?.valid) {
      const firstIssue = validation?.issues?.[0];
      const currentScreen = SCREENS[firstIssue?.screenId];
      const currentSection = sectionForScreen(firstIssue?.screenId);
      const nextOnes = currentScreen ? nextScreen(currentScreen.screenId, this.state.answers) : {};
      this.setState({
        currentScreen,
        currentSection,
        nextScreen: nextOnes.currentScreen,
        nextSection: nextOnes.currentSection,
        validationError: firstIssue?.message || 'Some answers need correction.',
      });
      return;
    }
    this.setState({ validationError: null });
    this.props.actions.submitForm(this.props.token);
  };

  reviewSteps = () => {
    this.setState({ sideNavOpen: true });
  };

  renderCompleted() {
    return (
      <View>
        <View style={[THEME.basicRow, { marginTop: 100, justifyContent: 'center' }]}>
          <Image
            style={styles.successImage}
            source={require('../../../resources/icon-success-thank-you.png')}
          />
        </View>
        <Text style={[THEME.textSemibold, { textAlign: 'center', marginTop: 30 }]}>
          PHA Part A Completed!
        </Text>
        <View style={[THEME.basicRow, { marginTop: 90 }]}>
          <CTAButton
            disabled={false}
            onPress={this.submit}
            label={'Submit PHA Part A'}
            style={{ flex: 1, marginTop: 4, marginHorizontal: 20, marginBottom: 30 }}
          />
        </View>
        <View style={[THEME.basicRow]}>
          <CTAButton
            disabled={false}
            onPress={this.reviewSteps}
            label={'Review Steps'}
            style={{
              flex: 1,
              marginHorizontal: 20,
              marginBottom: 30,
              borderColor: 'rgb(224, 224, 224)',
              borderWidth: 2,
              backgroundColor: 'white',
            }}
            fontStyle={{ color: COLOR.text }}
          />
        </View>
      </View>
    );
  }

  selfSchedule = () => {
    window.location.href = '/base/demo/pha';
  };

  renderSubmitted() {
    return (
      <View>
        <View style={[THEME.basicRow, { marginTop: 100, justifyContent: 'center' }]}>
          <Image
            style={styles.successImage}
            source={require('../../../resources/icon-success-thank-you-green.png')}
          />
        </View>
        <Text style={[THEME.textSemibold, { textAlign: 'center', marginTop: 30 }]}>
          PHA Part A Submitted!
        </Text>
        <Text style={[THEME.regular, { textAlign: 'center', marginTop: 30 }]}>
          Thank you for submitting your PHA Part A.
        </Text>
        <View style={[THEME.basicRow, { marginTop: 90 }]}>
          <CTAButton
            disabled={false}
            onPress={this.selfSchedule}
            label={'Self-Schedule Your PHA'}
            style={{ flex: 1, marginTop: 4, marginHorizontal: 20, marginBottom: 30 }}
          />
        </View>
      </View>
    );
  }

  nextLabel() {
    if (!this.state.nextSection) {
      return 'Next - Submit & Review';
    } else if (this.state.nextSection !== this.state.currentSection) {
      return `Next - ${this.state.nextSection.label}`;
    } else {
      return 'Next';
    }
  }

  render() {
    const props = this.props;
    const isVerticalLayout = this.state.isVerticalLayout;
    //valid=true;
    let valid = this.state.fieldsValid;

    const currentScreenState =
      this.state.currentScreen &&
      screenMeetsConditionsAndAnsweredAndValid(
        this.state.currentScreen.screenId,
        this.state.answers
      );
    if (currentScreenState) valid = valid && currentScreenState.valid;

    if (!this.state.questionnaireLoaded) {
      return (
        <View style={styles.container}>
          <View style={styles.innerContainer}>
            {this.renderHeader()}
            <Container renderActivityOverlay={true}>
              <Text style={{ padding: 25 }}>Loading the Part A questionnaire…</Text>
            </Container>
          </View>
        </View>
      );
    }

    return (
      <View style={styles.container}>
        <View style={styles.innerContainer}>
          {this.renderHeader()}
          {this.renderSidenav()}
          <Container
            ref={containerRef}
            scrollView={true}
            renderActivityOverlay={
              this.props.saveStatus === REQUESTING || this.props.submitStatus === REQUESTING
            }
            errorMessage={
              this.state.validationError ||
              (props.errorMessage
                ? props.errorMessage?.message || 'unknown error, please try again'
                : '')
            }
            confirmationOpts={this.state.confirmationOpts}
          >
            <View style={[styles.contents]}>
              {AGENT_ENABLED && props.submitStatus !== SUCCESS && (
                <View style={[THEME.basicRow, { justifyContent: 'flex-end', marginBottom: 10 }]}>
                  <CTAButton
                    disabled={false}
                    onPress={() => this.props.onSwitchMode('agent')}
                    label={'Use AI Guided Chat'}
                    style={{
                      marginRight: 20,
                      borderColor: COLOR.accent,
                      borderWidth: 1,
                      backgroundColor: COLOR.text,
                    }}
                    fontStyle={{ color: COLOR.contrast }}
                  />
                </View>
              )}
              {props.submitStatus !== SUCCESS && (
                <>
                  {this.state.currentScreen?.sections.map(this.renderQuestionGroup)}
                  {!!this.state.currentScreen && (
                    <View style={[THEME.basicRow, { marginTop: 40 }]}>
                      <CTAButton
                        disabled={!valid}
                        onPress={this.save}
                        label={this.nextLabel()}
                        style={{ flex: 1, marginTop: 4, marginHorizontal: 20, marginBottom: 30 }}
                      />
                    </View>
                  )}
                  {!this.state.currentScreen && props.status === REQUESTING && (
                    <View style={[THEME.basicRow, { marginTop: 40, padding: 25 }]}>
                      <Text>Loading your data...</Text>
                    </View>
                  )}
                  {!this.state.currentScreen && props.status === SUCCESS && this.renderCompleted()}
                </>
              )}
              {props.submitStatus === SUCCESS && this.renderSubmitted()}
            </View>
            <View
              style={[
                styles.overlay,
                {
                  transition: 'opacity 400ms ease-out',
                  opacity: this.state.sideNavOpen ? 1 : 0,
                  pointerEvents: this.state.sideNavOpen ? 'all' : 'none',
                },
              ]}
            />
          </Container>
        </View>
      </View>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    status: state.screens.partA.status,
    saveStatus: state.screens.partA.saveStatus,
    submitStatus: state.screens.partA.submitStatus,
    errorMessage: state.screens.partA.errorMessage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { getFormData, getQuestionnaire, putFormData, submitForm, validateForm },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PartAForm);
